import template from "./bModalDialog.html";

export function bModalDialogDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: bModalDialogController,
    controllerAs: 'bModalDialog',
    bindToController: true,
    transclude: true,
    scope: {
      config: "="
    }
  };

  return directive;
}

class bModalDialogController {
  constructor() {
    'ngInject';
  }

  resolve() {
    this.config.defer.resolve();
    this.config.shown = false;
  }

  reject(rejected) {
    this.config.defer.reject(rejected);
    this.config.shown = false;
  }
}
